'use strict';
define([
    'angular',
    'modules/keywordexplorer/keywordexplorer.routes',
    'modules/keywordexplorer/landing/landing.module'
], function (angular, routes) {
    var app = angular.module('app.keywordexplorer', [
        'app.keywordexplorer.landing'
    ]);
    app.config(routes);
    return app;
});
